// extracted by mini-css-extract-plugin
export default {"text":"hint_text__3JQ8r"};